import { render, staticRenderFns } from "./UserFeedback.vue?vue&type=template&id=eef63f32&scoped=true"
import script from "./UserFeedback.vue?vue&type=script&lang=js"
export * from "./UserFeedback.vue?vue&type=script&lang=js"
import style0 from "./UserFeedback.vue?vue&type=style&index=0&id=eef63f32&prod&lang=scss&scoped=true"
import style1 from "./UserFeedback.vue?vue&type=style&index=1&id=eef63f32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef63f32",
  null
  
)

export default component.exports